import React from 'react';

interface LumzaLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showTagline?: boolean;
}

const LumzaLogo = ({ className = '', size = 'md', showTagline = true }: LumzaLogoProps) => {
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl'
  };

  const moonSizes = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6', 
    lg: 'w-8 h-8'
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* Crescent Moon Icon */}
      <div className="relative">
        <svg 
          className={`${moonSizes[size]} text-neon glow-animation`}
          viewBox="0 0 24 24" 
          fill="currentColor"
        >
          <path d="M12 3a9 9 0 1 0 9 9c0-.46-.04-.92-.1-1.36a5.389 5.389 0 0 1-4.4 2.26 5.403 5.403 0 0 1-3.14-9.8c-.44-.06-.9-.1-1.36-.1z"/>
        </svg>
      </div>
      
      {/* Brand Text */}
      <div className="flex flex-col">
        <div className="flex items-center gap-1.5">
          <span className={`text-neon font-black tracking-tight glow-animation ${sizeClasses[size]}`}>
            LUMZA
          </span>
          <span className="bg-neon/15 text-neon border border-neon/30 text-[9px] font-bold uppercase px-1.5 py-0.5 rounded-full leading-none tracking-wider">
            Beta
          </span>
        </div>
        {showTagline && (
          <div className={`text-muted-foreground ${size === 'lg' ? 'text-sm' : 'text-xs'}`}>
            After-Hours
          </div>
        )}
      </div>
    </div>
  );
};

export default LumzaLogo;